import type { TourStep } from './GuidedTour';

/** Main app tour — shown on first login to introduce key ERP features */
export const APP_TOUR_ID = 'app-main-v1';

// title/content son claves i18n (GuidedTour las resuelve con fallback al
// literal): los textos viven en locales/es.json + en.json bajo `tour.app.*` —
// antes eran strings hardcoded en español y, encima, sin tildes.
export const appTourSteps: TourStep[] = [
  {
    target: 'navigation-menu',
    title: 'tour.app.nav.title',
    content: 'tour.app.nav.content',
    placement: 'right',
  },
  {
    target: 'layout-header',
    title: 'tour.app.header.title',
    content: 'tour.app.header.content',
    placement: 'bottom',
  },
  {
    target: 'ai-panel-toggle',
    title: 'tour.app.ai.title',
    content: 'tour.app.ai.content',
    placement: 'top',
  },
  {
    target: 'company-switcher',
    title: 'tour.app.company.title',
    content: 'tour.app.company.content',
    placement: 'bottom',
  },
  {
    target: 'command-menu-trigger',
    title: 'tour.app.search.title',
    content: 'tour.app.search.content',
    placement: 'bottom',
  },
];
